import { Card, CardContent, Typography, Grid, Divider } from "@mui/material";
import { AccountCircle, Badge, Email, Phone } from "@mui/icons-material";

const CandidatoInfo = ({ candidato }) => {
  if (!candidato) return null;

  return (
    <Card
      sx={{
        width: "100%",
        mb: 3,
        backgroundColor: "#ffffff",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        borderRadius: "10px",
        padding: 2,
      }}
    >
      <CardContent>
        <Typography variant="h5" fontWeight="bold" sx={{ mb: 2 }}>
          Información del Candidato
        </Typography>

        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={6} display="flex" alignItems="center">
            <AccountCircle sx={{ color: "#1976d2", mr: 1 }} />
            <Typography variant="body1">
              <strong>Nombre:</strong> {candidato.nombreApellido}
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6} display="flex" alignItems="center">
            <Badge sx={{ color: "#1976d2", mr: 1 }} />
            <Typography variant="body1">
              <strong>DNI:</strong> {candidato.dni}
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6} display="flex" alignItems="center">
            <Phone sx={{ color: "#1976d2", mr: 1 }} />
            <Typography variant="body1">
              <strong>Teléfono:</strong> {candidato.telefono}
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6} display="flex" alignItems="center">
            <Email sx={{ color: "#1976d2", mr: 1 }} />
            <Typography variant="body1">
              <strong>Correo:</strong> {candidato.mail}
            </Typography>
          </Grid>
        </Grid>

        <Divider sx={{ my: 2 }} />
      </CardContent>
    </Card>
  );
};

export default CandidatoInfo;
